module.exports = "table{width:100%}\n"